import { isSet } from '../utils/isSet';
import { HireDelivery } from './HireDelivery';
import { HirePeriod } from './HirePeriod';
import { HireSelection } from './HireSelection';

class Hire {
    constructor(root, place, AutocompleteSessionToken, AutocompleteSuggestion){
        this.root = root;
        this.place = place;
        this.AutocompleteSessionToken = AutocompleteSessionToken;
        this.AutocompleteSuggestion = AutocompleteSuggestion;

        this.hirePeriodWidget = this.root.querySelector('.hire-journey-widget--dates--js');
        this.hireDeliveryWidget = this.root.querySelector('.hire-journey-widget--delivery--js');
        this.hireSelectionWidget = this.root.querySelector('.hire-journey-widget--selection--js');

        this.init();
    }

    init(){
        if(isSet(this.hireDeliveryWidget)){
            new HireDelivery(this.hireDeliveryWidget, this.place, this.AutocompleteSessionToken, this.AutocompleteSuggestion);
        }

        if(isSet(this.hirePeriodWidget)){
            new HirePeriod(this.hirePeriodWidget);
        }

        if(isSet(this.hireSelectionWidget)){
            new HireSelection(this.hireSelectionWidget);
        }

        this.validate();
    }

    validate(){
        
    }
}

exports.Hire = Hire